module.exports = __webpack_public_path__ + "static/media/guide_phone.29cca698.png";